import React, { useEffect, useState} from 'react'
//components
import { Button } from '../components/ui/buttons/Button'
import Label from '../components/ui/labels/Label'
import { Input } from '../components/ui/inputs/Input'
import { InputContainer } from '../components/ui/inputs/InputContainers'
import { APIMessage } from '../components/ui/messages/APIMessage'
import { PasswordValidationErrors } from "../components/ui/messages/PasswordValidationErrors";
import { PageHeader } from '../components/ui/layout/PageHeader'
import { PageContainer } from '../components/ui/layout/PageContainer'
//hooks
import { useLoading } from "../contexts/LoadingContext"
import { useUser } from '../contexts/UserContext'
//api/utils
import { validatePassword } from '../utils/validatePassword'
import { changePasswordAPI } from "../services/authAPI"

/**
 * 
 * If user is logged in already, they can access this page to change their password.
 * 
 * @returns {JSX.Element}
 * 
 * @category Pages
 */
export const ChangePassword = () => {
    
    //set state

    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');

    const [validationErrors, setValidationErrors] = useState({})
    const [submitError, setSubmitError] = useState("")
    const [saveMessage, setSaveMessage] = useState(null)

    const { showLoading, hideLoading } = useLoading();

    const {user} = useUser()
   

    //validation

    const validate = () => {
        const errors = {}

        const passwordErrors = validatePassword(newPassword);

        if (passwordErrors.length > 0) {
            errors.password = passwordErrors
        }
    
        if(!oldPassword){
            errors.oldPassword = "Please enter your old password"
        }

        //if there are errors, set state to errors and return false
        if(Object.keys(errors).length > 0){
            setValidationErrors(errors)
            setSubmitError("Some fields are missing")
            return false
        }

        setValidationErrors({})
        setSubmitError("")

        return true
    }

    //submit new user
    const handleSubmit = async() => {
        showLoading("Changing password...")

        if(!validate()){
            hideLoading()
            return
        }

        const response = await changePasswordAPI(user.UserID, {
            oldPassword,
            newPassword
        })
                        
        if(!response.success){
            setSubmitError(response.message)
            setOldPassword("")
            setNewPassword("")
            
            hideLoading()
            
            return
        }

        //remove passwords from state
        setOldPassword("")
        setNewPassword("")
        
        setSaveMessage("Password changed")
        
        hideLoading()

        setTimeout(() => {
            setSaveMessage(null)
        }, 3000);
        
    }

    useEffect(() => {
        document.title =  `MarTrak - Change Password`
    }, []);

    return (
        <>
            <PageHeader pageTitle="Change Password"/>

            <PageContainer>

                {/* password */}
                <InputContainer>
                    <Label htmlFor='oldPassword' className='mb-2 font-semibold'>Old password</Label>
                    <Input 
                        type='text' 
                        name="oldPassword" 
                        value={oldPassword} 
                        onChange={(e)=>setOldPassword(e.target.value)}
                        error={validationErrors.oldPassword}
                        className="obscured-password"
                    />
                    <APIMessage message={validationErrors.oldPassword} isError={true} className="my-1 italic text-sm"/>
                </InputContainer>

                {/* confirm password */}
                <InputContainer>
                    <Label htmlFor='newPassword' className='mb-2 font-semibold'>New password</Label>
                    <Input 
                        type='text' 
                        name="newPassword" 
                        value={newPassword} 
                        onChange={(e)=>setNewPassword(e.target.value)}
                        error={validationErrors.password}
                        className="obscured-password"
                    />
                    <PasswordValidationErrors validationErrors={validationErrors} className="my-1 italic text-sm"/>
                </InputContainer>

                <div className='my-4'>
                    <Button variant="success" onClick={() => handleSubmit()}>Change Password</Button>
                    <APIMessage message={submitError} isError={true}/>
                </div>

                <APIMessage message={saveMessage} isError={false} />

            </PageContainer>
        </>

    )
}